"use client";

import { useState } from "react";
import { HeroSearch } from "@/components/help-center/hero-search";
import { QuickLinks } from "@/components/help-center/quick-links";
import { CategoriesSidebar } from "@/components/help-center/categories-sidebar";
import { PopularArticles } from "@/components/help-center/popular-articles";
import { VideoTutorials } from "@/components/help-center/video-tutorials";
import { FAQsSection } from "@/components/help-center/faqs-section";
import { ContactSupport } from "@/components/help-center/contact-support";
import { TopNavbar } from "@/components/top-navbar";

export default function HelpCenterPage() {
  const [activeCategory, setActiveCategory] = useState("getting-started");

  return (
    <div className="flex h-full min-h-0 flex-col bg-gray-50">
      <TopNavbar />
      <main className="flex min-h-0 flex-1 flex-col overflow-y-auto p-4 md:p-6 lg:p-8">
        <div className="dashboard-page-inner">
          {/* Hero Section: Search */}
          <HeroSearch />

          {/* Quick Links (4 cards) */}
          <QuickLinks />

          {/* Content Area (2 columns) */}
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            {/* Left: Categories Sidebar (25%) */}
            <CategoriesSidebar activeCategory={activeCategory} onCategoryChange={setActiveCategory} />

            {/* Right: Main Content (75%) */}
            <div className="flex-1 space-y-12">
              {/* Popular Articles */}
              <PopularArticles />

              {/* Video Tutorials */}
              <VideoTutorials />

              {/* FAQs Section */}
              <FAQsSection />

              {/* Contact Support */}
              <ContactSupport />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
